export const FLAG_GETTING_BUSINESS = "FLAG_GETTING_BUSINESS";
export const GET_BUSINESS = "GET_BUSINESS";
export const CLEAR_BUSINESS = "CLEAR_BUSINESS";
